import * as React from 'react'

import { trackEvent } from '../../../../../lib/analytics'
import { EmbroideryPlacementDetails } from '../../../../../types/graphql'
import {
  ErrorMessage,
  Label,
  ScrollableItemsContent,
  ScrollableItemsScrollableArea,
  ScrollableItemsWrapper,
  SelectedOptionText,
  SelectionButton,
} from '../../shared-form-styles'

export const PlacementSelector: React.FC<{
  errorMessage?: string
  label: string
  labelId: string
  onSelectPlacement(placement: EmbroideryPlacementDetails): void
  placementOptions: EmbroideryPlacementDetails[]
  selectedPlacementOption: EmbroideryPlacementDetails | undefined
}> = ({
  errorMessage,
  label,
  labelId,
  onSelectPlacement,
  placementOptions,
  selectedPlacementOption,
}) => {
  return (
    <>
      <Label id={labelId} inset>
        {label} <SelectedOptionText>{selectedPlacementOption?.name}</SelectedOptionText>
      </Label>

      <ScrollableItemsWrapper>
        <ScrollableItemsScrollableArea>
          <ScrollableItemsContent aria-labelledby={labelId} role='radiogroup'>
            {placementOptions.map((placementOption, index) => {
              const isSelected: boolean =
                selectedPlacementOption?.offsetKey === placementOption.offsetKey
              return (
                <SelectionButton
                  aria-checked={isSelected}
                  isSelected={isSelected}
                  key={index}
                  onClick={() => {
                    onSelectPlacement(placementOption)
                  }}
                  role='radio'
                  type='button'
                  {...trackEvent({
                    category: 'embroidery',
                    action: 'select placement',
                    label: placementOption.heapCtaName
                      ? placementOption.heapCtaName
                      : placementOption.name,
                    value: placementOption.heapCtaName
                      ? placementOption.heapCtaName
                      : placementOption.name,
                  })}
                >
                  {placementOption.name}
                </SelectionButton>
              )
            })}
          </ScrollableItemsContent>
        </ScrollableItemsScrollableArea>
      </ScrollableItemsWrapper>

      {errorMessage && (
        <ErrorMessage inset role='alert'>
          {errorMessage}
        </ErrorMessage>
      )}
    </>
  )
}
